import { TenantsApi } from '@linktivity/link-payment-admin';
import config from '../config';

const tenantsApi = new TenantsApi(config);

export default tenantsApi;
